import { inject, Injectable, signal } from '@angular/core';
import { ConfirmationDialogData } from '#models';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  private translateService = inject(TranslateService);

  dialogData = signal<ConfirmationDialogData | null>(null);
  visible = signal(false);

  openDialog(data: ConfirmationDialogData) {
    if (!data.confirmLabel) {
      data.confirmLabel = this.translateService.instant('app.forms.continue');
    }

    if (!data.cancelLabel) {
      data.cancelLabel = this.translateService.instant('app.forms.cancel');
    }

    this.dialogData.set(data);
    this.visible.set(true);
  }

  closeDialog() {
    this.visible.set(false);
    this.dialogData.set(null);
  }

  confirm() {
    const callback = this.dialogData()?.onConfirm;
    const result = callback ? callback() : undefined;

    if (result === false) {
      return;
    }

    this.closeDialog();
  }

  cancel() {
    const callback = this.dialogData()?.onCancel;
    if (callback) callback();
    this.closeDialog();
  }
}
